import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

import { BankcardTicket } from '../model/bankcard-ticket.model';
import { BankcardTransaction } from '../model/bankcard-transaction.model';

@Injectable()
export class BankcardTicketsActions {
    static FETCH_TRANSACTION = '[Bankcard Tickets]: Fetch transaction';
    static SET_TRANSACTION = '[Bankcard Tickets]: Set transaction';
    static SET_FAILED = '[Bankcard Tickets]: Set failed';

    static FETCH_TICKETS = '[Bankcard Tickets]: Fetch tickets';
    static SET_TICKETS = '[Bankcard Tickets]: Set tickets';
    static SET_TICKETS_FAILED = '[Bankcard Tickets]: Set tickets failed';

    static FETCH_HSL_TICKETS = '[Bankcard Tickets]: Fetch Hsl tickets';
    static SET_HSL_TICKETS = '[Bankcard Tickets]: Set Hsl tickets';
    static SET_HSL_TICKETS_FAILED = '[Bankcard Tickets]: Set Hsl tickets failed';

    static CLEAN_STATE = '[Bankcard Tickets]: Clean state';

    static SEND_FEEDBACK = '[Bankcard Tickets]: Send feedback';
    static SEND_FEEDBACK_SUCCESS = '[Bankcard Ticket]: Send feedback success';

    fetchTransaction(regionId: number): RidangoReduxAction {
        return {
            type: BankcardTicketsActions.FETCH_TRANSACTION,
            payload: regionId,
        };
    }

    setTransaction(transaction: BankcardTransaction): RidangoReduxAction {
        return {
            type: BankcardTicketsActions.SET_TRANSACTION,
            payload: transaction,
        };
    }

    fetchTickets(transactionId: number, lang: string = ''): RidangoReduxAction {
        return {
            type: BankcardTicketsActions.FETCH_TICKETS,
            payload: { transactionId: transactionId, lang: lang },
        };
    }

    setTickets(tickets: BankcardTicket[]): RidangoReduxAction {
        return {
            type: BankcardTicketsActions.SET_TICKETS,
            payload: tickets,
        };
    }

    setTicketsFailed(error: any): RidangoReduxAction {
        return {
            type: BankcardTicketsActions.SET_TICKETS_FAILED,
            payload: error,
        };
    }

    fetchHslTickets(transactionId: number): RidangoReduxAction {
        return {
            type: BankcardTicketsActions.FETCH_HSL_TICKETS,
            payload: transactionId,
        };
    }

    setHslTickets(tickets: BankcardTicket[]): RidangoReduxAction {
        return {
            type: BankcardTicketsActions.SET_HSL_TICKETS,
            payload: tickets,
        };
    }

    setHslTicketsFailed(error: any): RidangoReduxAction {
        return {
            type: BankcardTicketsActions.SET_HSL_TICKETS_FAILED,
            payload: error,
        };
    }

    setFailed(error: any): RidangoReduxAction {
        return {
            type: BankcardTicketsActions.SET_FAILED,
            payload: error,
        };
    }

    cleanState(): RidangoReduxAction {
        return {
            type: BankcardTicketsActions.CLEAN_STATE,
        };
    }

    sendFeedback(formData: any): RidangoReduxAction {
        return {
            type: BankcardTicketsActions.SEND_FEEDBACK,
            payload: formData,
        };
    }

    sendFeedbackSuccess(): RidangoReduxAction {
        return {
            type: BankcardTicketsActions.SEND_FEEDBACK_SUCCESS,
        };
    }
}
